import { StoreState } from '@/redux/types';
import { selectBasket } from './selectBasket';

export const selectBasketId = (state: StoreState) => selectBasket(state).id;
